<template>
  <div>
    <p :class="$style.content" v-html="message"></p>
    <div :class="$style.footer">
      <vs-button class="mr-2" type="flat" @click="modalReject">Нет</vs-button>
      <vs-button :color="buttonColor || 'danger'" @click="onSubmit">{{ buttonText || 'Да' }}</vs-button>
    </div>
  </div>
</template>

<script>
import modalContext from "../mixins/modalContext";

export default {
  name:    "ModalConfirm",
  mixins:  [modalContext],
  props:   ['message', 'buttonText', 'buttonColor', 'onAccept'],
  methods: {
    onSubmit() {
      if (typeof this.onAccept !== 'function') return this.modalResolve();
      Promise.resolve()
        .then(() => {
          this.$vs.loading({});
          return this.onAccept();
        })
        .then(() => {
          return this.modalResolve();
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
  },
};
</script>

<style lang="scss" module>
.content {
  padding-right: 12px;
}
.footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  position: relative;
  padding-top: 1rem;
  margin-top: 1rem;

  &:before {
    content: "";
    top: 0;
    position: absolute;
    left: 1rem;
    right: 1rem;
    height: 1px;
    background: #000;
    opacity: .05;
  }
}
</style>
